/* reel-carousel.js — v4 Performance + Close Fix — Upload to Shopify Assets */
function initReelCarousel() {
(function () {
  'use strict';

  /* ===== SVG ICONS ===== */
  var SVG_VOL_ON  = '<path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07" stroke="white" stroke-width="1.5" fill="none" stroke-linecap="round"/>';
  var SVG_VOL_OFF = '<path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15" stroke="white" stroke-width="1.5" stroke-linecap="round"/><line x1="17" y1="9" x2="23" y2="15" stroke="white" stroke-width="1.5" stroke-linecap="round"/>';
  var SVG_PLAY    = '<polygon points="5,3 19,12 5,21" fill="white"/>';
  var SVG_PAUSE   = '<rect x="6" y="4" width="4" height="16" fill="white"/><rect x="14" y="4" width="4" height="16" fill="white"/>';
  var SVG_CART    = '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="white" stroke-width="1.5" fill="none"/><line x1="3" y1="6" x2="21" y2="6" stroke="white" stroke-width="1.5"/><path d="M16 10a4 4 0 01-8 0" stroke="white" stroke-width="1.5" fill="none"/>';
  var SVG_CHECK   = '<polyline points="20 6 9 17 4 12" stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>';

  /* ===== STATE ===== */
  var globalMuted   = true;
  var currentPage   = 0;
  var cardWidth     = 0;
  var visibleCount  = 4;
  var maxPage       = 0;
  var activeProg    = null;
  var isAnimating   = false;
  var CLONE_COUNT   = 6;
  var GAP           = 16;

  /* Drawer */
  var drawerProduct     = null;
  var drawerVariants    = [];
  var selectedVariantId = null;
  var drawerQty         = 1;

  /* Mobile modal */
  var mReelIndex = 0;
  var mSlides    = [];
  var mRafProg   = null;
  var hintShown  = false;
  var mSwipeDir  = null;
  var mSwiping   = false;
  var mTouchY0   = 0;
  var mTouchX0   = 0;

  /* Performance: track visibility */
  var sectionVisible = false;

  /* ===== DOM ===== */
  var track         = document.getElementById('reelTrack');
  var outer         = document.getElementById('reelTrackOuter');
  var dotsWrap      = document.getElementById('reelDots');
  var btnPrev       = document.getElementById('reelPrev');
  var btnNext       = document.getElementById('reelNext');
  var modal         = document.getElementById('reelModal');
  var modalInner    = document.getElementById('reelModalInner');
  var modalVideo    = document.getElementById('modalVideo');
  var modalStack    = document.getElementById('modalStack');
  var modalClose    = document.getElementById('modalClose');
  var modalMuteBtn  = document.getElementById('modalMuteBtn');
  var modalMuteIcon = document.getElementById('modalMuteIcon');
  var modalPlayPause= document.getElementById('modalPlayPause');
  var modalPlayIcon = document.getElementById('modalPlayIcon');
  var modalTitle    = document.getElementById('modalTitle');
  var modalSub      = document.getElementById('modalSub');
  var modalTag      = document.getElementById('modalTag');
  var modalProgress = document.getElementById('modalProgress');
  var modalProgFill = document.getElementById('modalProgressFill');
  var swipeHint     = document.getElementById('swipeHint');

  /* Drawer DOM */
  var drawerOverlay   = document.getElementById('reelDrawerOverlay');
  var drawer          = document.getElementById('reelDrawer');
  var drawerCloseBtn  = document.getElementById('drawerCloseBtn');
  var drawerImage     = document.getElementById('drawerProductImage');
  var drawerTitle     = document.getElementById('drawerProductTitle');
  var drawerPrice     = document.getElementById('drawerPrice');
  var drawerPriceComp = document.getElementById('drawerPriceCompare');
  var drawerSaleBadge = document.getElementById('drawerSaleBadge');
  var drawerOptionsWrap = document.getElementById('drawerOptionsWrap');
  var drawerQtyVal    = document.getElementById('drawerQtyVal');
  var drawerQtyDec    = document.getElementById('drawerQtyDec');
  var drawerQtyInc    = document.getElementById('drawerQtyInc');
  var drawerBtnAtc    = document.getElementById('drawerBtnAtc');
  var drawerBtnBuy    = document.getElementById('drawerBtnBuy');
  var drawerViewLink  = document.getElementById('drawerViewLink');
  var reelToast       = document.getElementById('reelToast');

  if (!track) return;

  /* ===== READ REAL CARDS ===== */
  var realCards = Array.from(track.querySelectorAll('.reel-card:not(.reel-clone)'));
  var total     = realCards.length;
  if (total === 0) return;

  var reelData = realCards.map(function(c) {
    return {
      src:            c.dataset.src           || '',
      thumb:          c.dataset.thumb         || '',
      title:          c.dataset.title         || '',
      sub:            c.dataset.sub           || '',
      tag:            c.dataset.tag           || '',
      productHandle:  c.dataset.productHandle || '',
      productId:      c.dataset.productId     || '',
      productTitle:   c.dataset.productTitle  || '',
      productPrice:   c.dataset.productPrice  || '',
      productImage:   c.dataset.productImage  || '',
      productUrl:     c.dataset.productUrl    || ''
    };
  });

  /* ===== CLONE BUILD ===== */
  function buildClones() {
    for (var i = CLONE_COUNT - 1; i >= 0; i--) {
      var srcIdx = (total - CLONE_COUNT + i + total) % total;
      var clone  = realCards[srcIdx].cloneNode(true);
      clone.classList.add('reel-clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.realIndex = srcIdx;
      var cv = clone.querySelector('.reel-card__video');
      if (cv) { cv.removeAttribute('src'); cv.removeAttribute('data-loaded'); }
      bindCardEvents(clone, srcIdx);
      track.insertBefore(clone, track.firstChild);
    }
    for (var j = 0; j < CLONE_COUNT; j++) {
      var srcIdx2 = j % total;
      var clone2  = realCards[srcIdx2].cloneNode(true);
      clone2.classList.add('reel-clone');
      clone2.setAttribute('aria-hidden', 'true');
      clone2.dataset.realIndex = srcIdx2;
      var cv2 = clone2.querySelector('.reel-card__video');
      if (cv2) { cv2.removeAttribute('src'); cv2.removeAttribute('data-loaded'); }
      bindCardEvents(clone2, srcIdx2);
      track.appendChild(clone2);
    }
  }

  var allCards = [];
  function refreshAllCards() {
    allCards = Array.from(track.querySelectorAll('.reel-card'));
  }

  /* ===== CARD EVENTS ===== */
  function bindCardEvents(card, realIdx) {
    var mb  = card.querySelector('.reel-card__mute');
    var eb  = card.querySelector('.reel-card__expand');
    var pin = card.querySelector('.reel-card__product-pin');
   if (mb)  mb.addEventListener('click',  function(e) { e.stopPropagation(); toggleCardMute(card); });
    if (eb)  eb.addEventListener('click',  function(e) { e.stopPropagation(); openModal(realIdx); });
    if (pin) pin.addEventListener('click', function(e) {
      e.stopPropagation();
      if (isMobile()) {
        /* Mobile: open reel modal first, then slide drawer up over it */
        openModal(realIdx);
        /* Small delay so modal animation starts before drawer opens */
        setTimeout(function() { openDrawer(realIdx); }, 180);
      } else {
        /* Desktop: open split modal (video + product panel on right) */
        openModal(realIdx);
      }
    });
    card.addEventListener('click', function(e) {
      if (mb  && mb.contains(e.target))  return;
      if (eb  && eb.contains(e.target))  return;
      if (pin && pin.contains(e.target)) return;
      var v  = card.querySelector('.reel-card__video');
      var pi = card.querySelector('.reel-card__play-icon');
      if (!v) return;
      if (v.paused) { stopAll(); playCard(card); }
      else { v.pause(); if (pi) pi.classList.remove('hide'); card.classList.remove('is-active'); }
    });
  }
  realCards.forEach(function(card, idx) { bindCardEvents(card, idx); });

  /* ===== MEASURE ===== */
  function measure() {
    var w = window.innerWidth;
    if      (w >= 1200) visibleCount = 5;
    else if (w >= 900)  visibleCount = 4;
    else if (w >= 600)  visibleCount = 3;
    else                visibleCount = 2;
    cardWidth = realCards[0] ? realCards[0].offsetWidth : 200;
    maxPage   = Math.max(0, total - visibleCount);
  }

  /* ===== TRANSFORMS ===== */
  function getX(page) { return -((page + CLONE_COUNT) * (cardWidth + GAP)); }
  function applyTransform(x, animated) {
    track.style.transition = animated ? 'transform .42s cubic-bezier(.4,0,.2,1)' : 'none';
    track.style.transform  = 'translateX(' + x + 'px)';
  }

  /* ===== NAVIGATION ===== */
  function goTo(page, animated) {
    if (typeof animated === 'undefined') animated = true;
    currentPage = ((page % total) + total) % total;
    applyTransform(getX(currentPage), animated);
    updateDots();
  }

  function goNext() {
    if (isAnimating) return;
    isAnimating = true;
    var animToPage = currentPage + 1;
    applyTransform(getX(animToPage), true);
    track.addEventListener('transitionend', function handler() {
      track.removeEventListener('transitionend', handler);
      if (animToPage >= total) {
        currentPage = 0;
        applyTransform(getX(0), false);
        void track.offsetWidth;
      } else {
        currentPage = animToPage;
      }
      updateDots();
      /* FIX 3: ensure all real cards keep autoplaying after navigation */
      ensureAllPlaying();
      isAnimating = false;
    });
  }

 function goPrev() {
    if (isAnimating) return;
    isAnimating = true;
    var animToPage = currentPage - 1;
    applyTransform(getX(animToPage), true);
    track.addEventListener('transitionend', function handler() {
      track.removeEventListener('transitionend', handler);
      if (animToPage < 0) {
        currentPage = total - 1;
        applyTransform(getX(total - 1), false);
        void track.offsetWidth;
      } else {
        currentPage = animToPage;
      }
      updateDots();
      /* FIX 3: ensure all real cards keep autoplaying after navigation */
      ensureAllPlaying();
      isAnimating = false;
    });
  }

  /* ===== DOTS ===== */
  function renderDots() {
    dotsWrap.innerHTML = '';
    var pageCount = maxPage + 1;
    for (var i = 0; i < pageCount; i++) {
      (function(i) {
        var dot = document.createElement('button');
        dot.className = 'reel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to reel ' + (i + 1));
        dot.addEventListener('click', function() { goTo(i); autoPlayVisible(); });
        dotsWrap.appendChild(dot);
      })(i);
    }
  }

  function updateDots() {
    var dots = dotsWrap.querySelectorAll('.reel-dot');
    var p    = ((currentPage % (maxPage + 1)) + (maxPage + 1)) % (maxPage + 1);
    dots.forEach(function(d, i) { d.classList.toggle('active', i === p); });
  }

  /* ===== VIDEO PLAY — MOBILE FIX =====
     Root causes of mobile 2-3s stop:
     1. iOS requires muted autoplay — always start muted
     2. preload="none" in HTML means no buffer — load() lazily in JS
     3. readyState check is unreliable — use 'canplay' event
     4. loop attribute alone unreliable on some Android — use 'ended' listener too
     5. Suspend/resume: pause ALL non-visible videos to free decode bandwidth
  ===== */
  function stopAll() {
    allCards.forEach(function(card) {
      var v  = card.querySelector('.reel-card__video');
      var t  = card.querySelector('.reel-card__thumb');
      var pi = card.querySelector('.reel-card__play-icon');
      if (!v) return;
      v.pause();
      /* Free mobile decoder bandwidth — remove src from off-screen videos */
      if (!card.classList.contains('is-active')) {
        v.classList.remove('playing');
      }
      if (t)  t.classList.remove('hidden');
      if (pi) pi.classList.remove('hide');
      card.classList.remove('is-active');
    });
    if (activeProg) { cancelAnimationFrame(activeProg); activeProg = null; }
  }

  function playCard(card) {
    var v  = card.querySelector('.reel-card__video');
    var t  = card.querySelector('.reel-card__thumb');
    var pi = card.querySelector('.reel-card__play-icon');
    var pf = card.querySelector('.reel-card__progress-fill');
    if (!v) return;
    var src = card.dataset.src;
    if (!src) return;

    /* Lazy-load src — critical: don't set src in HTML preload="none" */
    if (v.getAttribute('data-loaded') !== src) {
      v.removeAttribute('src');
      v.src = src;
      v.setAttribute('data-loaded', src);
      v.muted = true;   /* MUST be muted for iOS autoplay */
      v.load();         /* MUST call load() after setting src on iOS */
    }

    v.muted = globalMuted;
    v.loop  = true;
    v.playsInline = true;

    /* Ensure loop works on all Android browsers */
    if (!v._loopBound) {
      v._loopBound = true;
      v.addEventListener('ended', function() {
        if (card.classList.contains('is-active')) {
          v.currentTime = 0;
          v.play().catch(function() {});
        }
      });
    }

    function doPlay() {
      /* Reset currentTime to prevent stale frame on re-play */
      var playPromise = v.play();
      if (playPromise !== undefined) {
        playPromise.then(function() {
          v.classList.add('playing');
          if (t)  t.classList.add('hidden');
          if (pi) pi.classList.add('hide');
          card.classList.add('is-active');
          tickProg(v, pf);
        }).catch(function(err) {
          console.warn('[Reel] Play blocked:', err.message);
          /* Show play icon so user can tap to start */
          if (pi) pi.classList.remove('hide');
        });
      }
    }

    /* Use 'canplaythrough' for smoother start on mobile */
    if (v.readyState >= 3) {
      doPlay();
    } else {
      /* Remove old listener first to avoid stacking */
      v.removeEventListener('canplay', v._playHandler);
      v._playHandler = function() { doPlay(); };
      v.addEventListener('canplay', v._playHandler, { once: true });
    }
  }

  function tickProg(video, fill) {
    if (activeProg) cancelAnimationFrame(activeProg);
    function step() {
      if (fill && !video.paused && video.duration) {
        fill.style.width = (video.currentTime / video.duration * 100) + '%';
      }
      activeProg = requestAnimationFrame(step);
    }
    activeProg = requestAnimationFrame(step);
  }
function ensureAllPlaying() {
    if (!sectionVisible) return;
    realCards.forEach(function(card) {
      var v  = card.querySelector('.reel-card__video');
      var t  = card.querySelector('.reel-card__thumb');
      var pi = card.querySelector('.reel-card__play-icon');
      if (!v || !card.dataset.src) return;

      /* Re-apply correct mute state */
      v.muted = (activeUnmutedCard === card) ? false : true;
      v.loop  = true;

      /* If video lost its src or got unloaded, reload it */
      if (v.getAttribute('data-loaded') !== card.dataset.src) {
        v.src = card.dataset.src;
        v.setAttribute('data-loaded', card.dataset.src);
        v.load();
      }

      if (v.paused) {
        v.play().then(function() {
          v.classList.add('playing');
          if (t)  t.classList.add('hidden');
          if (pi) pi.classList.add('hide');
        }).catch(function() {
          /* If blocked, try reloading and playing */
          v.load();
          setTimeout(function() {
            v.play().then(function() {
              v.classList.add('playing');
              if (t)  t.classList.add('hidden');
              if (pi) pi.classList.add('hide');
            }).catch(function() {});
          }, 300);
        });
      }
    });
    updateAllMuteIcons();
  }
 function autoPlayVisible() {
    if (!sectionVisible) return;
    /* Play ALL real cards always — muted background autoplay */
    realCards.forEach(function(card) {
      var v  = card.querySelector('.reel-card__video');
      var t  = card.querySelector('.reel-card__thumb');
      var pi = card.querySelector('.reel-card__play-icon');
      if (!v || !card.dataset.src) return;

      /* Skip if already playing */
      if (!v.paused && v.getAttribute('data-loaded') === card.dataset.src) return;

      v.muted   = (activeUnmutedCard === card) ? false : true;
      v.loop    = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');

      if (v.getAttribute('data-loaded') !== card.dataset.src) {
        v.src = card.dataset.src;
        v.setAttribute('data-loaded', card.dataset.src);
        v.load();
      }

      var fired = false;
      function doPlay() {
        if (fired) return; fired = true;
        v.removeEventListener('loadeddata', doPlay);
        v.muted = (activeUnmutedCard === card) ? false : true;
        v.play().then(function() {
          v.classList.add('playing');
          if (t)  t.classList.add('hidden');
          if (pi) pi.classList.add('hide');
        }).catch(function() {});
      }

      if (v.readyState >= 3) {
        doPlay();
      } else {
        v.addEventListener('loadeddata', doPlay);
        setTimeout(function() {
          if (!fired) { fired = true; v.play().then(function(){ v.classList.add('playing'); if(t) t.classList.add('hidden'); if(pi) pi.classList.add('hide'); }).catch(function(){}); }
        }, 1500);
      }
    });

    updateAllMuteIcons();
  }

 /* activeUnmutedCard: tracks which single card is currently unmuted */
  var activeUnmutedCard = null;

  function updateAllMuteIcons() {
    allCards.forEach(function(c) {
      var mb = c.querySelector('.reel-card__mute svg');
      if (!mb) return;
      /* Show unmuted icon only for the actively unmuted card */
      var v = c.querySelector('.reel-card__video');
      var isThisUnmuted = (v && !v.muted);
      mb.innerHTML = isThisUnmuted ? SVG_VOL_ON : SVG_VOL_OFF;
    });
    if (modalMuteIcon) modalMuteIcon.innerHTML = globalMuted ? SVG_VOL_OFF : SVG_VOL_ON;
  }

  function toggleCardMute(card) {
    var v  = card.querySelector('.reel-card__video');
    var mb = card.querySelector('.reel-card__mute svg');
    if (!v) return;

    var isCurrentlyMuted = v.muted;

    if (isCurrentlyMuted) {
      /* User wants to UNMUTE this card */
      /* First, mute all other cards */
      allCards.forEach(function(c) {
        var cv = c.querySelector('.reel-card__video');
        var cmb = c.querySelector('.reel-card__mute svg');
        if (cv) cv.muted = true;
        if (cmb) cmb.innerHTML = SVG_VOL_OFF;
      });
      /* Unmute only this card */
      v.muted = false;
      if (mb) mb.innerHTML = SVG_VOL_ON;
      activeUnmutedCard = card;
      /* Sync global flag so modal knows state */
      globalMuted = false;
    } else {
      /* User wants to MUTE this card back */
      v.muted = true;
      if (mb) mb.innerHTML = SVG_VOL_OFF;
      activeUnmutedCard = null;
      globalMuted = true;
    }

    /* Sync modal video mute state */
    if (modalVideo) modalVideo.muted = globalMuted;
    mSlides.forEach(function(s) { if (s.video) s.video.muted = globalMuted; });
  }

  function toggleGlobalMute() {
    /* Used only by modal mute button — mutes/unmutes modal video */
    globalMuted = !globalMuted;
    if (modalVideo) modalVideo.muted = globalMuted;
    mSlides.forEach(function(s) { if (s.video) s.video.muted = globalMuted; });
    if (modalMuteIcon) modalMuteIcon.innerHTML = globalMuted ? SVG_VOL_OFF : SVG_VOL_ON;
  }

  /* ===== DRAG / SWIPE — optimized with passive listeners ===== */
  var dragX = 0, dragging = false, dragMoved = false;
  var touchX0 = 0, touchY0 = 0, cTouchDir = null;

  outer.addEventListener('mousedown', function(e) {
    dragging = true; dragMoved = false; dragX = e.clientX;
    outer.style.cursor = 'grabbing';
  });
  /* Use document for mousemove/up so drag works outside element */
  document.addEventListener('mousemove', function(e) {
    if (!dragging) return;
    if (Math.abs(e.clientX - dragX) > 8) dragMoved = true;
  });
  document.addEventListener('mouseup', function(e) {
    if (!dragging) return;
    dragging = false; outer.style.cursor = 'grab';
    if (!dragMoved) return;
    var diff = dragX - e.clientX;
    if (diff > 40) goNext(); else if (diff < -40) goPrev();
  });

  outer.addEventListener('touchstart', function(e) {
    touchX0 = e.touches[0].clientX;
    touchY0 = e.touches[0].clientY;
    cTouchDir = null;
  }, { passive: true });

  outer.addEventListener('touchmove', function(e) {
    if (!cTouchDir) {
      var dx = Math.abs(e.touches[0].clientX - touchX0);
      var dy = Math.abs(e.touches[0].clientY - touchY0);
      cTouchDir = dx > dy ? 'h' : 'v';
    }
    /* Only preventDefault for horizontal swipes — lets page scroll vertically */
    if (cTouchDir === 'h') e.preventDefault();
  }, { passive: false });

  outer.addEventListener('touchend', function(e) {
    if (cTouchDir !== 'h') return;
    var diff = touchX0 - e.changedTouches[0].clientX;
    if (diff > 40) goNext(); else if (diff < -40) goPrev();
  }, { passive: true });

  if (btnPrev) btnPrev.addEventListener('click', goPrev);
  if (btnNext) btnNext.addEventListener('click', goNext);

  /* ===== MONEY FORMAT ===== */
  /* ===== MONEY FORMAT ===== */
  function moneyFormat(cents) {
    /* Shopify product.js returns variant prices as strings like "849.00" (rupees)
       but cart/storefront APIs return integers in paise (84900).
       Detect: if the value has a decimal point in its string form, treat as rupees.
       If large integer (>=100000), divide by 100 (paise to rupees).
       Otherwise treat as rupees directly (static data-product-price values). */
    var raw = parseFloat(cents);
    if (isNaN(raw)) return '\u20B9' + cents;
    var amount;
    if (String(cents).indexOf('.') !== -1) {
      /* Has decimal — already in rupees (e.g. "849.00" from product.js) */
      amount = Math.round(raw);
    } else if (raw >= 100000) {
      /* Large integer — paise, divide by 100 */
      amount = Math.round(raw / 100);
    } else {
      /* Small integer, no decimal — already rupees (e.g. data-product-price="849") */
      amount = Math.round(raw);
    }
    /* Indian number formatting: last 3 digits, then groups of 2 */
    var s = amount.toString();
    if (s.length > 3) {
      var last3 = s.slice(-3);
      var rest  = s.slice(0, -3);
      rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      return '\u20B9' + rest + ',' + last3;
    }
    return '\u20B9' + s;
  }

  /* ===== PRODUCT DRAWER ===== */
  function fetchProduct(handle, cb) {
    if (!handle) { cb(null); return; }
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) { cb(data); })
      .catch(function() { cb(null); });
  }

  function openDrawer(reelIdx) {
    var d = reelData[reelIdx];
    if (!d || !d.productHandle) return;
/* FIX 3 mobile: do NOT close modal — drawer slides up over it */
    /* Modal stays open behind the drawer on mobile */
    /* Pre-fill with static data while fetching */
    if (drawerTitle)    drawerTitle.textContent = d.productTitle || 'Loading…';
    if (drawerImage)    { drawerImage.src = d.productImage || ''; drawerImage.alt = d.productTitle || ''; }
    if (drawerPrice)    drawerPrice.textContent = d.productPrice ? moneyFormat(d.productPrice) : '…';
    if (drawerPriceComp)  { drawerPriceComp.textContent = ''; drawerPriceComp.style.display = 'none'; }
    if (drawerSaleBadge)  drawerSaleBadge.style.display = 'none';
    if (drawerOptionsWrap) drawerOptionsWrap.innerHTML = '';
    if (drawerViewLink) drawerViewLink.href = d.productUrl || ('/products/' + d.productHandle);
    drawerQty = 1;
    if (drawerQtyVal) drawerQtyVal.textContent = '1';
    selectedVariantId = null;

    /* Open drawer FIRST for instant feel */
    drawerOverlay.classList.add('open');
    drawer.classList.add('open');

    fetchProduct(d.productHandle, function(product) {
      if (!product) return;
      drawerProduct  = product;
      drawerVariants = product.variants;

      if (product.images && product.images.length > 0 && drawerImage) {
        drawerImage.src = product.images[0];
      }
      if (drawerTitle) drawerTitle.textContent = product.title;

      var firstVar = product.variants[0];
      selectedVariantId = firstVar.id;
      updateDrawerPrice(firstVar);

      if (drawerViewLink) drawerViewLink.href = '/products/' + product.handle;
      renderDrawerOptions(product);
    });
  }

function updateDrawerPrice(variant) {
    if (!variant) return;
    var price        = parseInt(variant.price, 10);
    var comparePrice = parseInt(variant.compare_at_price, 10);

    if (drawerPrice) drawerPrice.textContent = moneyFormat(price);

    /* Sync the hidden Shiprocket product form so their SDK can read the variant */
    var srVariantInput = document.getElementById('reel-shiprocket-variant-id');
    var srQtyInput     = document.getElementById('reel-shiprocket-qty');
    if (srVariantInput) srVariantInput.value = variant.id;
    if (srQtyInput)     srQtyInput.value     = drawerQty || 1;

    if (comparePrice && comparePrice > price) {
      if (drawerPriceComp) { drawerPriceComp.textContent = moneyFormat(comparePrice); drawerPriceComp.style.display = ''; }
      if (drawerSaleBadge) {
        var pct = Math.round((1 - price / comparePrice) * 100);
        drawerSaleBadge.textContent = '-' + pct + '%';
        drawerSaleBadge.style.display = '';
      }
    } else {
      if (drawerPriceComp) drawerPriceComp.style.display = 'none';
      if (drawerSaleBadge) drawerSaleBadge.style.display = 'none';
    }

    if (drawerBtnAtc) {
      drawerBtnAtc.disabled = !variant.available;
      var lbl = drawerBtnAtc.querySelector('.reel-drawer__btn-label');
      if (lbl) lbl.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    if (drawerBtnBuy) drawerBtnBuy.disabled = !variant.available;
  }

  function renderDrawerOptions(product) {
    if (!drawerOptionsWrap) return;
    drawerOptionsWrap.innerHTML = '';
    /* Single default variant — no option UI needed */
    if (product.options.length === 1 && product.options[0].name === 'Title' && product.variants.length === 1) return;

    product.options.forEach(function(option, optIdx) {
      var group = document.createElement('div');
      group.style.marginBottom = '14px';

      var lbl = document.createElement('div');
      lbl.className = 'reel-drawer__label';
      lbl.textContent = option.name;
      group.appendChild(lbl);

      var btnsRow = document.createElement('div');
      btnsRow.className = 'reel-drawer__variants';

      var isColor = /colou?r/i.test(option.name);

      option.values.forEach(function(val) {
        var btn = document.createElement('button');
        btn.className = 'reel-drawer__variant-btn' + (isColor ? ' is-swatch' : '');
        btn.dataset.option = optIdx;
        btn.dataset.value  = val;
        if (isColor) { btn.style.backgroundColor = val.toLowerCase().replace(/\s+/g, ''); btn.title = val; }
        else { btn.textContent = val; }

        var available = product.variants.some(function(v) {
          return v['option' + (optIdx + 1)] === val && v.available;
        });
        if (!available) btn.classList.add('unavailable');

        btn.addEventListener('click', function() {
          if (btn.classList.contains('unavailable')) return;
          btnsRow.querySelectorAll('.reel-drawer__variant-btn').forEach(function(b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          updateSelectedVariant(product);
        });

        if (available && !btnsRow.querySelector('.reel-drawer__variant-btn.selected:not(.unavailable)')) {
          btn.classList.add('selected');
        }
        btnsRow.appendChild(btn);
      });

      group.appendChild(btnsRow);
      drawerOptionsWrap.appendChild(group);
    });

    updateSelectedVariant(product);
  }

  function updateSelectedVariant(product) {
    var selected = {};
    drawerOptionsWrap.querySelectorAll('.reel-drawer__variant-btn.selected').forEach(function(btn) {
      selected[parseInt(btn.dataset.option, 10)] = btn.dataset.value;
    });
    var matched = product.variants.find(function(v) {
      return product.options.every(function(opt, i) {
        return !selected[i] || v['option' + (i + 1)] === selected[i];
      });
    });
    if (matched) {
      selectedVariantId = matched.id;
      updateDrawerPrice(matched);
      if (matched.featured_image && drawerImage) {
        drawerImage.src = matched.featured_image.src || matched.featured_image;
      }
    }
  }

  /* ===== CLOSE DRAWER — multiple ways ===== */
  function closeDrawer() {
    drawer.classList.remove('open');
    drawerOverlay.classList.remove('open');
    drawerProduct     = null;
    selectedVariantId = null;
    drawerQty         = 1;
  }

  /* 1. X button */
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);

  /* 2. Click on the dark overlay outside drawer */
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', function(e) {
      /* Only close if clicking the overlay itself, not bubbled from inside drawer */
      if (e.target === drawerOverlay) closeDrawer();
    });
  }

  /* 3. Swipe down to close on mobile (touch on the drawer handle area) */
  if (drawer) {
    var dTouchStartY = 0;
    drawer.addEventListener('touchstart', function(e) {
      dTouchStartY = e.touches[0].clientY;
    }, { passive: true });
    drawer.addEventListener('touchend', function(e) {
      var dy = e.changedTouches[0].clientY - dTouchStartY;
      if (dy > 80) closeDrawer();
    }, { passive: true });
  }

  /* 4. Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeModal(); closeDrawer(); }
  });

  /* Quantity */
if (drawerQtyDec) {
    drawerQtyDec.addEventListener('click', function() {
      if (drawerQty > 1) {
        drawerQty--;
        if (drawerQtyVal) drawerQtyVal.textContent = drawerQty;
        var srQty = document.getElementById('reel-shiprocket-qty');
        if (srQty) srQty.value = drawerQty;
      }
    });
  }
  if (drawerQtyInc) {
    drawerQtyInc.addEventListener('click', function() {
      drawerQty++;
      if (drawerQtyVal) drawerQtyVal.textContent = drawerQty;
      var srQty = document.getElementById('reel-shiprocket-qty');
      if (srQty) srQty.value = drawerQty;
    });
  }

  /* Add to Cart */
  if (drawerBtnAtc) {
    drawerBtnAtc.addEventListener('click', function() {
      if (!selectedVariantId) return;
      drawerBtnAtc.disabled = true;
      drawerBtnAtc.innerHTML = '<span class="reel-spinner"></span>';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: drawerQty })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        drawerBtnAtc.innerHTML = '<svg viewBox="0 0 24 24">' + SVG_CHECK + '</svg><span class="reel-drawer__btn-label">Added!</span>';
        drawerBtnAtc.style.background = '#2a7a3b';
        showToast('Added to cart!', true);
        updateCartCount();
        setTimeout(function() {
          drawerBtnAtc.disabled = false;
          drawerBtnAtc.style.background = '';
          drawerBtnAtc.innerHTML = '<svg viewBox="0 0 24 24">' + SVG_CART + '</svg><span class="reel-drawer__btn-label">Add to Cart</span>';
        }, 2200);
      })
      .catch(function() {
        drawerBtnAtc.disabled = false;
        drawerBtnAtc.innerHTML = '<svg viewBox="0 0 24 24">' + SVG_CART + '</svg><span class="reel-drawer__btn-label">Add to Cart</span>';
        showToast('Something went wrong. Try again.', false);
      });
    });
  }

  /* Buy Now */
if (drawerBtnBuy) {
    drawerBtnBuy.addEventListener('click', function() {
      if (!selectedVariantId) return;

      /* Ensure the hidden form is synced */
      var srVariantInput = document.getElementById('reel-shiprocket-variant-id');
      var srQtyInput     = document.getElementById('reel-shiprocket-qty');
      if (srVariantInput) srVariantInput.value = selectedVariantId;
      if (srQtyInput)     srQtyInput.value     = drawerQty;

      /* Try to trigger Shiprocket's checkout button if it exists on the page */
      /* Shiprocket renders a button with class .shiprocket-checkout-btn or #shiprocket-checkout */
      var srBtn = document.querySelector(
        '.shiprocket-checkout-btn, #shiprocket-checkout, [data-shiprocket-checkout], .sr-checkout-btn'
      );

      if (srBtn) {
        /* Add to cart first, then trigger Shiprocket button */
        drawerBtnBuy.disabled = true;
        drawerBtnBuy.innerHTML = '<span class="reel-spinner"></span>';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: selectedVariantId, quantity: drawerQty })
        })
        .then(function() {
          drawerBtnBuy.disabled = false;
          drawerBtnBuy.innerHTML = 'Buy Now';
          closeDrawer();
          /* Small delay to let cart state settle, then click Shiprocket button */
          setTimeout(function() { srBtn.click(); }, 150);
        })
        .catch(function() {
          drawerBtnBuy.disabled = false;
          drawerBtnBuy.innerHTML = 'Buy Now';
          showToast('Something went wrong. Try again.', false);
        });
      } else {
        /* Shiprocket button not found — fallback to standard checkout */
        drawerBtnBuy.disabled = true;
        drawerBtnBuy.innerHTML = '<span class="reel-spinner"></span>';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: selectedVariantId, quantity: drawerQty })
        })
        .then(function() { window.location.href = '/checkout'; })
        .catch(function() {
          drawerBtnBuy.disabled = false;
          drawerBtnBuy.innerHTML = 'Buy Now';
          showToast('Something went wrong. Try again.', false);
        });
      }
    });
  }

function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count;
        /* 1. Update all known DOM selectors across popular themes */
        var els = document.querySelectorAll([
          '[data-cart-count]',
          '[data-cart-item-count]',
          '.cart-count',
          '.cart__count',
          '.cart-count-bubble',
          '.header__cart-count',
          '.cart-icon-bubble__num',
          '.cart-items-count',
          '[data-header-cart-count]',
          '.site-header__cart-count',
          '.mini-cart__count',
          '.js-cart-count'
        ].join(','));
        els.forEach(function(el) {
          el.textContent = count;
          /* Show the bubble if it was hidden (Dawn theme hides it at 0) */
          el.classList.remove('hidden', 'is-hidden', 'hide');
          el.removeAttribute('hidden');
          if (el.parentElement) {
            el.parentElement.classList.remove('hidden', 'is-hidden', 'hide');
            el.parentElement.removeAttribute('hidden');
          }
        });
        /* 2. Fire the standard Shopify cart:updated event (works in Dawn, Debut, etc.) */
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        /* 3. Fire the cart-update event used by some third-party apps */
        document.dispatchEvent(new CustomEvent('cart-update', { detail: { cart: cart } }));
        /* 4. Dawn theme specifically uses this */
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        /* 5. Dispatch a native change event on any cart forms (triggers theme JS listeners) */
        var cartForms = document.querySelectorAll('form[action="/cart"]');
        cartForms.forEach(function(f) { f.dispatchEvent(new Event('change', { bubbles: true })); });
      })
      .catch(function() {});
  }

  function showToast(msg, success) {
    if (!reelToast) return;
    reelToast.innerHTML = (success ? '<svg viewBox="0 0 24 24">' + SVG_CHECK + '</svg>' : '') + msg;
    reelToast.classList.add('show');
    clearTimeout(reelToast._t);
    reelToast._t = setTimeout(function() { reelToast.classList.remove('show'); }, 2800);
  }

  /* ===== MODAL ===== */
  function isMobile() { return window.innerWidth <= 768; }

 function openModal(reelIdx) {
    /* FIX 2: pause all background card videos */
    allCards.forEach(function(c) {
      var v = c.querySelector('.reel-card__video');
      if (v && !v.paused) v.pause();
    });

    modal.classList.add('open');
    document.body.style.overflow = 'hidden';

    if (isMobile()) {
      /* ── MOBILE: full-screen reel stack ── */
      buildMobileStack(reelIdx);
      if (!hintShown) {
        hintShown = true;
        if (swipeHint) {
          swipeHint.classList.add('show');
          setTimeout(function() { swipeHint.classList.remove('show'); }, 2400);
        }
      }
    } else {
      /* ── DESKTOP: split video + product panel (FIX 3) ── */
      openDesktopSplitModal(reelIdx);
    }
  }
/* ===== DESKTOP SPLIT MODAL ===== */
  var panelQty = 1;
  var panelVariantId = null;
  var panelProduct = null;

  function openDesktopSplitModal(reelIdx) {
    var d = reelData[reelIdx];
    if (!d) return;

    /* Restructure modal inner for split layout */
    modalInner.classList.add('split-mode');
    modalInner.innerHTML = '';

    /* ── LEFT: video side ── */
    var videoSide = document.createElement('div');
    videoSide.className = 'reel-modal__video-side';

    var vid = document.createElement('video');
    vid.className = 'reel-modal__video';
    vid.id = 'modalVideo';
    vid.setAttribute('playsinline', '');
    vid.setAttribute('webkit-playsinline', '');
    vid.loop  = true;
    vid.muted = globalMuted;
    videoSide.appendChild(vid);

    /* Grad + meta overlay on video */
    var gradBot = document.createElement('div');
    gradBot.className = 'reel-modal__grad-bot';
    videoSide.appendChild(gradBot);

    /* Progress bar */
    var prog = document.createElement('div');
    prog.className = 'reel-modal__progress';
    prog.id = 'modalProgress';
    var progFill = document.createElement('div');
    progFill.className = 'reel-modal__progress-fill';
    progFill.id = 'modalProgressFill';
    prog.appendChild(progFill);
    prog.addEventListener('click', function(e) {
      var r = prog.getBoundingClientRect();
      if (vid.duration) vid.currentTime = ((e.clientX - r.left) / r.width) * vid.duration;
    });
    videoSide.appendChild(prog);

    /* Controls */
    var controls = document.createElement('div');
    controls.className = 'reel-modal__controls';
    controls.innerHTML =
      '<button class="reel-modal__ctrl-btn" id="modalMuteBtn" aria-label="Toggle mute">' +
        '<svg id="modalMuteIcon" viewBox="0 0 24 24">' + (globalMuted ? SVG_VOL_OFF : SVG_VOL_ON) + '</svg>' +
      '</button>' +
      '<button class="reel-modal__ctrl-btn" id="modalPlayPause" aria-label="Play or Pause">' +
        '<svg id="modalPlayIcon" viewBox="0 0 24 24">' + SVG_PAUSE + '</svg>' +
      '</button>';
    videoSide.appendChild(controls);

    /* Close button */
    var closeBtn = document.createElement('button');
    closeBtn.className = 'reel-modal__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    closeBtn.addEventListener('click', closeModal);
    videoSide.appendChild(closeBtn);

    /* ── RIGHT: product panel ── */
    var productSide = document.createElement('div');
    productSide.className = 'reel-modal__product-side';
    productSide.id = 'modalProductSide';
    productSide.innerHTML =
      '<div class="reel-product-panel__images">' +
        '<img class="reel-product-panel__main-img" id="panelMainImg" src="' + (d.productImage || '') + '" alt="' + (d.productTitle || '') + '">' +
        '<div class="reel-product-panel__thumbs" id="panelThumbs"></div>' +
      '</div>' +
      '<div class="reel-product-panel__title" id="panelTitle">' + (d.productTitle || 'Loading…') + '</div>' +
      '<div class="reel-product-panel__prices">' +
        '<span class="reel-product-panel__price" id="panelPrice">' + (d.productPrice ? moneyFormat(d.productPrice) : '…') + '</span>' +
        '<span class="reel-product-panel__compare" id="panelCompare" style="display:none"></span>' +
        '<span class="reel-product-panel__sale-badge" id="panelSale" style="display:none"></span>' +
      '</div>' +
      '<div class="reel-product-panel__divider"></div>' +
      '<div id="panelOptionsWrap"></div>' +
      '<div class="reel-product-panel__divider"></div>' +
      '<div class="reel-product-panel__label">Quantity</div>' +
      '<div class="reel-product-panel__qty-row">' +
        '<div class="reel-product-panel__qty">' +
          '<button class="reel-product-panel__qty-btn" id="panelQtyDec">&#8722;</button>' +
          '<span class="reel-product-panel__qty-val" id="panelQtyVal">1</span>' +
          '<button class="reel-product-panel__qty-btn" id="panelQtyInc">&#43;</button>' +
        '</div>' +
      '</div>' +
      '<div class="reel-product-panel__actions">' +
        '<button class="reel-product-panel__btn-atc" id="panelBtnAtc">' +
          '<svg viewBox="0 0 24 24">' + SVG_CART + '</svg>' +
          '<span id="panelAtcLabel">Add to Cart</span>' +
        '</button>' ;
      

    modalInner.appendChild(videoSide);
    modalInner.appendChild(productSide);

    /* Re-assign modalVideo reference after DOM rebuild */
    modalVideo = vid;

    /* Bind new controls */
    var newMuteBtn  = videoSide.querySelector('#modalMuteBtn');
    var newMuteIcon = videoSide.querySelector('#modalMuteIcon');
    var newPPBtn    = videoSide.querySelector('#modalPlayPause');
    var newPPIcon   = videoSide.querySelector('#modalPlayIcon');
    if (newMuteBtn) newMuteBtn.addEventListener('click', function() {
      globalMuted = !globalMuted;
      vid.muted = globalMuted;
      if (newMuteIcon) newMuteIcon.innerHTML = globalMuted ? SVG_VOL_OFF : SVG_VOL_ON;
      updateAllMuteIcons();
    });
    if (newPPBtn) newPPBtn.addEventListener('click', function() {
      if (vid.paused) { vid.play().catch(function(){}); if (newPPIcon) newPPIcon.innerHTML = SVG_PAUSE; }
      else { vid.pause(); if (newPPIcon) newPPIcon.innerHTML = SVG_PLAY; }
    });

    /* Play video */
    vid.src = d.src;
    vid.load();
    vid.addEventListener('canplay', function onCan() {
      vid.removeEventListener('canplay', onCan);
      vid.play().catch(function() {});
    });
    vid.addEventListener('timeupdate', function() {
      if (progFill && vid.duration) progFill.style.width = (vid.currentTime / vid.duration * 100) + '%';
    });

    /* Qty controls */
    panelQty = 1; panelVariantId = null; panelProduct = null;
    var pQtyVal = productSide.querySelector('#panelQtyVal');
    var pQtyDec = productSide.querySelector('#panelQtyDec');
    var pQtyInc = productSide.querySelector('#panelQtyInc');
    if (pQtyDec) pQtyDec.addEventListener('click', function() {
      if (panelQty > 1) { panelQty--; if (pQtyVal) pQtyVal.textContent = panelQty; }
    });
    if (pQtyInc) pQtyInc.addEventListener('click', function() {
      panelQty++; if (pQtyVal) pQtyVal.textContent = panelQty;
    });

    /* ATC */
    var pBtnAtc = productSide.querySelector('#panelBtnAtc');
    var pAtcLbl = productSide.querySelector('#panelAtcLabel');
    if (pBtnAtc) pBtnAtc.addEventListener('click', function() {
      if (!panelVariantId) return;
      pBtnAtc.disabled = true;
      pBtnAtc.innerHTML = '<span class="reel-spinner"></span>';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: panelVariantId, quantity: panelQty })
      }).then(function() {
        pBtnAtc.innerHTML = '<svg viewBox="0 0 24 24">' + SVG_CHECK + '</svg><span>Added!</span>';
        pBtnAtc.style.background = '#2a7a3b';
        showToast('Added to cart!', true);
        updateCartCount();
        setTimeout(function() {
          pBtnAtc.disabled = false;
          pBtnAtc.style.background = '';
          pBtnAtc.innerHTML = '<svg viewBox="0 0 24 24">' + SVG_CART + '</svg><span>Add to Cart</span>';
        }, 2200);
      }).catch(function() {
        pBtnAtc.disabled = false;
        pBtnAtc.innerHTML = '<svg viewBox="0 0 24 24">' + SVG_CART + '</svg><span>Add to Cart</span>';
        showToast('Something went wrong.', false);
      });
    });

    /* Buy Now */
    var pBtnBuy = productSide.querySelector('#panelBtnBuy');
    if (pBtnBuy) pBtnBuy.addEventListener('click', function() {
      if (!panelVariantId) return;
      pBtnBuy.disabled = true;
      pBtnBuy.innerHTML = '<span class="reel-spinner"></span>';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: panelVariantId, quantity: panelQty })
      }).then(function() {
        window.location.href = '/checkout';
      }).catch(function() {
        pBtnBuy.disabled = false;
        pBtnBuy.innerHTML = 'Buy Now';
        showToast('Something went wrong.', false);
      });
    });

    /* Fetch full product for images + variants */
    if (d.productHandle) {
      fetch('/products/' + d.productHandle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          panelProduct = product;
          var firstVar = product.variants[0];
          panelVariantId = firstVar.id;

          /* Product title */
          var pTitle = productSide.querySelector('#panelTitle');
          if (pTitle) pTitle.textContent = product.title;

          /* Images */
          var mainImg  = productSide.querySelector('#panelMainImg');
          var thumbsWrap = productSide.querySelector('#panelThumbs');
          if (product.images && product.images.length > 0) {
            if (mainImg) mainImg.src = product.images[0];
            if (thumbsWrap && product.images.length > 1) {
              product.images.slice(0, 5).forEach(function(imgSrc, i) {
                var th = document.createElement('img');
                th.className = 'reel-product-panel__thumb' + (i === 0 ? ' active' : '');
                th.src = imgSrc; th.width = 56; th.height = 56;
                th.addEventListener('click', function() {
                  if (mainImg) mainImg.src = imgSrc;
                  thumbsWrap.querySelectorAll('.reel-product-panel__thumb').forEach(function(t) { t.classList.remove('active'); });
                  th.classList.add('active');
                });
                thumbsWrap.appendChild(th);
              });
            }
          }

          /* Price */
          updatePanelPrice(firstVar, productSide);

          /* Variants/Options */
          var optWrap = productSide.querySelector('#panelOptionsWrap');
          renderPanelOptions(product, optWrap, productSide);
        }).catch(function() {});
    }
  }

  function updatePanelPrice(variant, productSide) {
    if (!variant || !productSide) return;
    var priceEl   = productSide.querySelector('#panelPrice');
    var compareEl = productSide.querySelector('#panelCompare');
    var saleEl    = productSide.querySelector('#panelSale');
    var atcBtn    = productSide.querySelector('#panelBtnAtc');
    var buyBtn    = productSide.querySelector('#panelBtnBuy');
    var price     = parseInt(variant.price, 10);
    var compare   = parseInt(variant.compare_at_price, 10);
    if (priceEl) priceEl.textContent = moneyFormat(price);
    if (compare && compare > price) {
      if (compareEl) { compareEl.textContent = moneyFormat(compare); compareEl.style.display = ''; }
      if (saleEl) { saleEl.textContent = '-' + Math.round((1 - price / compare) * 100) + '%'; saleEl.style.display = ''; }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (saleEl) saleEl.style.display = 'none';
    }
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      var lbl = atcBtn.querySelector('span');
      if (lbl) lbl.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    if (buyBtn) buyBtn.disabled = !variant.available;
  }

  function renderPanelOptions(product, optWrap, productSide) {
    if (!optWrap) return;
    optWrap.innerHTML = '';
    if (product.options.length === 1 && product.options[0].name === 'Title' && product.variants.length === 1) return;
    product.options.forEach(function(option, optIdx) {
      var group = document.createElement('div');
      group.style.marginBottom = '14px';
      var lbl = document.createElement('div');
      lbl.className = 'reel-product-panel__label';
      lbl.textContent = option.name;
      group.appendChild(lbl);
      var row = document.createElement('div');
      row.className = 'reel-product-panel__variants';
      var isColor = /colou?r/i.test(option.name);
      option.values.forEach(function(val) {
        var btn = document.createElement('button');
        btn.className = 'reel-product-panel__variant-btn' + (isColor ? ' is-swatch' : '');
        btn.dataset.option = optIdx; btn.dataset.value = val;
        if (isColor) { btn.style.backgroundColor = val.toLowerCase().replace(/\s+/g, ''); btn.title = val; }
        else { btn.textContent = val; }
        var avail = product.variants.some(function(v) { return v['option' + (optIdx + 1)] === val && v.available; });
        if (!avail) btn.classList.add('unavailable');
        btn.addEventListener('click', function() {
          if (btn.classList.contains('unavailable')) return;
          row.querySelectorAll('.reel-product-panel__variant-btn').forEach(function(b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          updatePanelSelectedVariant(product, optWrap, productSide);
        });
        if (avail && !row.querySelector('.reel-product-panel__variant-btn.selected:not(.unavailable)')) btn.classList.add('selected');
        row.appendChild(btn);
      });
      group.appendChild(row);
      optWrap.appendChild(group);
    });
    updatePanelSelectedVariant(product, optWrap, productSide);
  }

  function updatePanelSelectedVariant(product, optWrap, productSide) {
    var selected = {};
    optWrap.querySelectorAll('.reel-product-panel__variant-btn.selected').forEach(function(btn) {
      selected[parseInt(btn.dataset.option, 10)] = btn.dataset.value;
    });
    var matched = product.variants.find(function(v) {
      return product.options.every(function(opt, i) { return !selected[i] || v['option' + (i + 1)] === selected[i]; });
    });
    if (matched) {
      panelVariantId = matched.id;
      updatePanelPrice(matched, productSide);
      if (matched.featured_image) {
        var mainImg = productSide.querySelector('#panelMainImg');
        if (mainImg) mainImg.src = matched.featured_image.src || matched.featured_image;
      }
    }
  }
  function renderDesktopModalPin(reelIdx) {
    var existing = document.getElementById('modalDesktopPin');
    if (existing) existing.remove();
    var d = reelData[reelIdx];
    if (!d.productHandle) return;
    var pin = document.createElement('div');
    pin.id = 'modalDesktopPin';
    pin.className = 'reel-slide__product-pin';
    pin.innerHTML =
      '<img class="reel-slide__product-pin-img" src="' + (d.productImage || '') + '" alt="' + d.productTitle + '" width="42" height="42">' +
      '<div class="reel-slide__product-pin-info">' +
        '<div class="reel-slide__product-pin-name">' + (d.productTitle || '') + '</div>' +
        '<div class="reel-slide__product-pin-price">' + (d.productPrice ? moneyFormat(d.productPrice) : '') + '</div>' +
      '</div>' +
      '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>';
    pin.addEventListener('click', function() { openDrawer(reelIdx); });
    document.getElementById('reelModalInner').appendChild(pin);
  }

  function closeModal() {
    modal.classList.remove('open');
    document.body.style.overflow = '';

    /* Stop all modal videos */
    if (modalVideo) { modalVideo.pause(); try { modalVideo.src = ''; } catch(e){} }
    if (modalProgFill) modalProgFill.style.width = '0%';
    if (modalVideo) modalVideo.removeEventListener('timeupdate', onDesktopProg);

    /* Clean up mobile stack */
    mSlides.forEach(function(s) { if (s.video) { s.video.pause(); try { s.video.src = ''; } catch(e){} } });
    if (modalStack) modalStack.innerHTML = '';
    mSlides = [];
    if (mRafProg) { cancelAnimationFrame(mRafProg); mRafProg = null; }

    /* Reset split-mode inner */
    if (modalInner) {
      modalInner.classList.remove('split-mode');
      /* Restore original inner HTML for next open */
      modalInner.innerHTML =
        '<video class="reel-modal__video" id="modalVideo" muted playsinline loop webkit-playsinline></video>' +
        '<div class="reel-modal__stack" id="modalStack"></div>' +
        '<div id="modalDesktopOverlay">' +
          '<div class="reel-modal__grad-bot"></div>' +
          '<div class="reel-modal__meta">' +
            '<span class="reel-modal__meta-tag" id="modalTag"></span>' +
            '<div class="reel-modal__meta-title" id="modalTitle"></div>' +
            '<div class="reel-modal__meta-sub" id="modalSub"></div>' +
          '</div>' +
          '<div class="reel-modal__progress" id="modalProgress">' +
            '<div class="reel-modal__progress-fill" id="modalProgressFill"></div>' +
          '</div>' +
        '</div>' +
        '<button class="reel-modal__close" id="modalClose" aria-label="Close">' +
          '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="reel-modal__controls">' +
          '<button class="reel-modal__ctrl-btn" id="modalMuteBtn" aria-label="Toggle mute">' +
            '<svg id="modalMuteIcon" viewBox="0 0 24 24"></svg>' +
          '</button>' +
          '<button class="reel-modal__ctrl-btn" id="modalPlayPause" aria-label="Play or Pause">' +
            '<svg id="modalPlayIcon" viewBox="0 0 24 24"></svg>' +
          '</button>' +
        '</div>' +
        '<div class="reel-swipe-hint" id="swipeHint">' +
          '<svg viewBox="0 0 24 24"><polyline points="18 15 12 9 6 15"/></svg>' +
          '<span>Swipe up for next reel</span>' +
        '</div>';

      /* Re-grab references */
      modalVideo    = document.getElementById('modalVideo');
      modalStack    = document.getElementById('modalStack');
      modalClose    = document.getElementById('modalClose');
      modalMuteBtn  = document.getElementById('modalMuteBtn');
      modalMuteIcon = document.getElementById('modalMuteIcon');
      modalPlayPause= document.getElementById('modalPlayPause');
      modalPlayIcon = document.getElementById('modalPlayIcon');
      modalTitle    = document.getElementById('modalTitle');
      modalSub      = document.getElementById('modalSub');
      modalTag      = document.getElementById('modalTag');
      modalProgress = document.getElementById('modalProgress');
      modalProgFill = document.getElementById('modalProgressFill');
      swipeHint     = document.getElementById('swipeHint');

      /* Re-bind static events */
      if (modalClose) modalClose.addEventListener('click', closeModal);
      if (modalMuteBtn) modalMuteBtn.addEventListener('click', toggleGlobalMute);
      if (modalPlayPause) modalPlayPause.addEventListener('click', function() {
        if (isMobile()) {
          var center = mSlides[1]; if (!center || !center.video) return;
          if (center.video.paused) center.video.play().catch(function(){}); else center.video.pause();
          if (modalPlayIcon) modalPlayIcon.innerHTML = center.video.paused ? SVG_PLAY : SVG_PAUSE;
        } else {
          if (modalVideo.paused) modalVideo.play().catch(function(){}); else modalVideo.pause();
          if (modalPlayIcon) modalPlayIcon.innerHTML = modalVideo.paused ? SVG_PLAY : SVG_PAUSE;
        }
      });
    }

    /* FIX 2: Resume background videos */
    if (sectionVisible) {
      realCards.forEach(function(card) {
        var v = card.querySelector('.reel-card__video');
        if (v && v.getAttribute('data-loaded') && v.paused) v.play().catch(function(){});
      });
    }
  }

  function onDesktopProg() {
    if (modalVideo && modalVideo.duration && modalProgFill) {
      modalProgFill.style.width = (modalVideo.currentTime / modalVideo.duration * 100) + '%';
    }
  }
  function updateDesktopPlayIcon() {
    if (modalPlayIcon) modalPlayIcon.innerHTML = modalVideo.paused ? SVG_PLAY : SVG_PAUSE;
  }

  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
  if (modalMuteBtn) modalMuteBtn.addEventListener('click', toggleGlobalMute);

  if (modalPlayPause) {
    modalPlayPause.addEventListener('click', function() {
      if (isMobile()) {
        var center = mSlides[1]; if (!center || !center.video) return;
        if (center.video.paused) center.video.play().catch(function() {}); else center.video.pause();
        if (modalPlayIcon) modalPlayIcon.innerHTML = center.video.paused ? SVG_PLAY : SVG_PAUSE;
      } else {
        if (modalVideo.paused) modalVideo.play().catch(function() {}); else modalVideo.pause();
        updateDesktopPlayIcon();
      }
    });
  }
  if (modalVideo) { modalVideo.addEventListener('play', updateDesktopPlayIcon); modalVideo.addEventListener('pause', updateDesktopPlayIcon); }
  if (modalProgress) {
    modalProgress.addEventListener('click', function(e) {
      var r = modalProgress.getBoundingClientRect();
      if (modalVideo) modalVideo.currentTime = ((e.clientX - r.left) / r.width) * (modalVideo.duration || 0);
    });
  }

  /* ===== MOBILE STACK ===== */
  function buildMobileStack(startIdx) {
    if (modalStack) modalStack.innerHTML = '';
    mSlides = [];
    if (mRafProg) { cancelAnimationFrame(mRafProg); mRafProg = null; }
    mReelIndex = ((startIdx % total) + total) % total;

    var indices = [(mReelIndex - 1 + total) % total, mReelIndex, (mReelIndex + 1) % total];
    indices.forEach(function(dataIdx, pos) {
      var slide = document.createElement('div');
      slide.className = 'reel-modal__slide';
      slide.style.cssText = 'position:absolute;left:0;right:0;height:100%;top:' + ((pos - 1) * 100) + '%;transition:none;';

      var v = document.createElement('video');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('x-webkit-airplay', 'deny');
      v.loop    = true;
      v.muted   = globalMuted;
      v.preload = 'auto';
      v.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;transform:translateZ(0);';

      /* Loop fallback for Android */
      v.addEventListener('ended', function() {
        v.currentTime = 0;
        v.play().catch(function() {});
      });

      var gradBot = document.createElement('div');
      gradBot.className = 'reel-modal__grad-bot';

      var meta = document.createElement('div');
      meta.className = 'reel-modal__meta';
      meta.innerHTML =
        '<span class="reel-modal__meta-tag">'  + (reelData[dataIdx].tag   || '') + '</span>' +
        '<div class="reel-modal__meta-title">' + (reelData[dataIdx].title || '') + '</div>' +
        '<div class="reel-modal__meta-sub">'   + (reelData[dataIdx].sub   || '') + '</div>';

      var prog = document.createElement('div');
      prog.className = 'reel-modal__progress';
      var fill = document.createElement('div');
      fill.className = 'reel-modal__progress-fill';
      prog.appendChild(fill);
      prog.addEventListener('click', function(e) {
        var r = prog.getBoundingClientRect();
        v.currentTime = ((e.clientX - r.left) / r.width) * (v.duration || 0);
      });

      /* Product pin */
      var rd = reelData[dataIdx];
      if (rd.productHandle) {
        var pin = document.createElement('div');
        pin.className = 'reel-slide__product-pin';
        pin.innerHTML =
          '<img class="reel-slide__product-pin-img" src="' + (rd.productImage || '') + '" alt="' + (rd.productTitle || '') + '" width="42" height="42">' +
          '<div class="reel-slide__product-pin-info">' +
            '<div class="reel-slide__product-pin-name">' + (rd.productTitle || '') + '</div>' +
            '<div class="reel-slide__product-pin-price">' + (rd.productPrice ? moneyFormat(rd.productPrice) : '') + '</div>' +
          '</div>' +
          '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>';
        pin.addEventListener('click', function(e) { e.stopPropagation(); openDrawer(dataIdx); });
        slide.appendChild(pin);
      }

      slide.appendChild(v);
      slide.appendChild(gradBot);
      slide.appendChild(meta);
      slide.appendChild(prog);
      if (modalStack) modalStack.appendChild(slide);
      mSlides.push({ el: slide, video: v, fill: fill, dataIdx: dataIdx });

      v.src = reelData[dataIdx].src;
      v.load();
    });

    /* Play center slide */
    var center = mSlides[1];
    if (center && center.video) {
      center.video.addEventListener('canplay', function onCan() {
        center.video.removeEventListener('canplay', onCan);
        center.video.play().catch(function() {});
        if (modalPlayIcon) modalPlayIcon.innerHTML = SVG_PAUSE;
      }, { once: true });
      /* Preload neighbors silently */
      if (mSlides[0] && mSlides[0].video) mSlides[0].video.load();
      if (mSlides[2] && mSlides[2].video) mSlides[2].video.load();
      tickMobileProg(center.video, center.fill);
    }
    if (modalMuteIcon) modalMuteIcon.innerHTML = globalMuted ? SVG_VOL_OFF : SVG_VOL_ON;
  }

  function tickMobileProg(video, fill) {
    if (mRafProg) cancelAnimationFrame(mRafProg);
    function step() {
      if (fill && !video.paused && video.duration) {
        fill.style.width = (video.currentTime / video.duration * 100) + '%';
      }
      mRafProg = requestAnimationFrame(step);
    }
    mRafProg = requestAnimationFrame(step);
  }

  function mobileNavigate(direction) {
    var nextIdx = direction === 'up' ? (mReelIndex + 1) % total : (mReelIndex - 1 + total) % total;
    mSlides.forEach(function(s, i) {
      var newTop = ((i - 1) + (direction === 'up' ? -1 : 1)) * 100;
      s.el.style.transition = 'top .35s cubic-bezier(.4,0,.2,1)';
      s.el.style.top = newTop + '%';
    });
    setTimeout(function() {
      mSlides.forEach(function(s) {
        if (s.video) { s.video.pause(); s.video.currentTime = 0; }
      });
      buildMobileStack(nextIdx);
    }, 370);
  }

  /* ===== MOBILE MODAL TOUCH ===== */
  if (modalInner) {
    modalInner.addEventListener('touchstart', function(e) {
      mTouchY0 = e.touches[0].clientY;
      mTouchX0 = e.touches[0].clientX;
      mSwiping  = false;
      mSwipeDir = null;
    }, { passive: true });

    modalInner.addEventListener('touchmove', function(e) {
      if (!isMobile()) return;
      var dy = e.touches[0].clientY - mTouchY0;
      var dx = e.touches[0].clientX - mTouchX0;
      if (!mSwipeDir) { mSwipeDir = Math.abs(dy) > Math.abs(dx) ? 'v' : 'h'; }
      if (mSwipeDir === 'v') {
        e.preventDefault();
        mSwiping = true;
        mSlides.forEach(function(s, i) {
          s.el.style.transition = 'none';
          s.el.style.top = 'calc(' + ((i - 1) * 100) + '% + ' + dy + 'px)';
        });
      }
    }, { passive: false });

    modalInner.addEventListener('touchend', function(e) {
      if (!isMobile() || !mSwiping) return;
      mSwiping = false;
      var dy = e.changedTouches[0].clientY - mTouchY0;
      if (Math.abs(dy) > 70) {
        mobileNavigate(dy < 0 ? 'up' : 'down');
      } else {
        mSlides.forEach(function(s, i) {
          s.el.style.transition = 'top .3s cubic-bezier(.4,0,.2,1)';
          s.el.style.top = ((i - 1) * 100) + '%';
        });
      }
    }, { passive: true });
  }

  /* ===== INTERSECTION OBSERVER — pause when off screen ===== */
  function startAutoplay() { goTo(0, false); autoPlayVisible(); }

  if ('IntersectionObserver' in window) {
   var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        sectionVisible = entry.isIntersecting;
        if (entry.isIntersecting) {
          autoPlayVisible();
        } else {
          /* Pause all when off screen — saves battery */
          realCards.forEach(function(card) {
            var v = card.querySelector('.reel-card__video');
            if (v && !v.paused) v.pause();
          });
        }
      });
    }, { threshold: 0.15 });
    var section = document.getElementById('reel-carousel-section');
    if (section) obs.observe(section);
  } else {
    sectionVisible = true;
    startAutoplay();
  }

  /* ===== RESIZE ===== */
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() { measure(); renderDots(); goTo(currentPage, false); }, 150);
  });

  /* ===== INIT ===== */
  buildClones();
  refreshAllCards();
  measure();
  renderDots();
  goTo(0, false);

})();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReelCarousel);
} else {
  initReelCarousel();
}
document.addEventListener('shopify:section:load', function(e) {
  if (e.target && e.target.querySelector('#reel-carousel-section')) { initReelCarousel(); }
});